module.exports = __webpack_public_path__ + "static/media/specialsWeekly.a97ec2c5.png";